module.exports = __webpack_public_path__ + "img/icon-chevron-right.d3c347f5.svg";